import React, { useEffect } from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { Nav } from '../components/Nav';
import { Hero } from '../components/Hero';
import { Rule } from '../components/Rule';
import { ClientStrip } from '../components/ClientStrip';
import { Projects } from '../components/Projects';
import { Services } from '../components/Services';
import { Toolchain } from '../components/Toolchain';
import { Testimonial } from '../components/Testimonial';
import { Faq } from '../components/Faq';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
type HomeProps = {
  accent: 'violet' | 'signal';
};
export function Home({
  accent
}: HomeProps) {
  // Jump to the section in the URL hash when arriving from a subpage (e.g. /#faq).
  useEffect(() => {
    document.title = 'Konrad Walz · CAD-Konstruktion';
    const hash = window.location.hash.slice(1);
    if (!hash) return;
    const id = window.setTimeout(() => document.getElementById(hash)?.scrollIntoView(), 50);
    return () => window.clearTimeout(id);
  }, []);
  return <div lang="de" data-accent={accent} className="min-h-screen w-full bg-white font-sans text-ink antialiased" data-id="element-654" data-mp="2vxf3fz13ewej">
      <AnnouncementBar data-id="element-655" data-mp="2qxkfa38pckx6" />
      <Nav data-id="element-656" data-mp="2qwshqmvjod49" />
      <main data-id="element-657" data-mp="2r0oo5dx444u6">
        <Hero data-id="element-658" data-mp="2mx0hqyk7vfai" />
        <Rule data-id="element-659" data-mp="2mxa50edvn8ci" />
        <ClientStrip data-id="element-660" data-mp="2mxs0h8sptijd" />
        <Projects data-id="element-661" data-mp="2mwgxvcb0agtu" />
        <Services data-id="element-662" data-mp="2mz351atziubj" />
        <Rule data-id="element-663" data-mp="2hxx9l58xwsyb" />
        <Toolchain data-id="element-664" data-mp="2hxnmbpfa4zwb" />
        <Testimonial data-id="element-665" data-mp="2hyyyacivpdyi" />
        <Faq data-id="element-666" data-mp="2hzi3csnfk7v4" />
        <Contact data-id="element-667" data-mp="2i00a4j7py4ha" />
      </main>
      <Footer data-id="element-668" data-mp="2d7gxppkrpfe2" />
    </div>;
}